import React, { useState } from 'react';
import { Popover as AntdPopOver} from 'antd';
import { isMobile } from '../../util';
import close from "../../../../../../assets/icons/close-circle.svg";

const Popover = (props) => {
  const { enablePopover} = props;
  const [ hovered, setHovered] = useState(false);
  const isMobileDevice = isMobile();
  const hidePopover = () =>{
    setHovered(false);  
  }
  const handleHoverChange = visible => {
    setHovered(visible);    
  };
  return enablePopover ? <AntdPopOver
    overlayClassName={`step-custom-popover ${props.overlayClassName}`}
    trigger={ isMobileDevice ? 'click' : 'hover' }
    content={<>
        {props.onHoverContents}
        {isMobileDevice && <img src={close} className="popover-close" onClick={hidePopover}/>}
      </>
    }
    visible={hovered}
    onVisibleChange = {handleHoverChange}
    placement={ isMobileDevice ? 'bottomLeft' : 'right' }    
  >
    {props.children}
  </AntdPopOver> : <>{props.children}</>
}

export default Popover;